var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"200px"}},[_c('slim-cropper',{attrs:{"options":_vm.slimOptions,"data-label":"Drop your image here","id":_vm.selector}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }